import { RouteObject } from "react-router";

const routes: RouteObject = {
    path: '/login',
    lazy: {
        Component: async () => (
            (await import('./Login')).default
        ),
    },
};

export default routes;
